import { ref } from 'vue';

interface UseReaderShareOptions {
  showControlsForCurrentViewport: () => void;
  /** 未显式传锚点时的兜底锚点（通常取控制条上的分享按钮位置）。 */
  resolveShareAnchor: () => DOMRect | null;
}

/** 分享域：分享面板显隐与锚点定位。 */
export const useReaderShare = (options: UseReaderShareOptions) => {
  const { showControlsForCurrentViewport, resolveShareAnchor } = options;

  const shareVisible = ref(false);
  const shareAnchorRect = ref<DOMRect | null>(null);

  const shareBook = (anchor?: DOMRect) => {
    showControlsForCurrentViewport();
    shareAnchorRect.value = anchor ?? resolveShareAnchor();
    shareVisible.value = true;
  };

  return { shareVisible, shareAnchorRect, shareBook };
};
